module.exports = __webpack_public_path__ + "img/ctrl-aggregate-stub-up-0.85411176.svg";